import React from 'react';
import { Clock, AlertTriangle } from 'lucide-react';

import { Icon } from '@epoch-ui/components/Icon';
import { cn } from '@epoch-ui/lib/utils';

interface EmptyStateProps {
  className?: string;
}

export const NoRegistrationsYet: React.FC<EmptyStateProps> = ({ className = '' }) => {
  return (
    <div
      className={cn(
        'tw-flex tw-flex-col tw-items-center tw-justify-center tw-rounded-md tw-border',
        'tw-border-dashed tw-border-border-grey tw-py-6 tw-text-center',
        className
      )}
    >
      <Icon name="users-round" className="tw-mb-2 tw-text-medium-grey" strokeWidth={2.5} />
      <p className="tw-m-0 tw-text-sm tw-font-normal tw-leading-5 tw-text-primary-grey">
        No registrations yet
      </p>
    </div>
  );
};

export const RegistrationWasReset: React.FC<EmptyStateProps> = ({ className = '' }) => {
  return (
    <div
      className={cn(
        'tw-flex tw-flex-col tw-items-center tw-justify-center tw-rounded-md tw-border',
        'tw-border-dashed tw-border-border-grey tw-py-6 tw-text-center',
        className
      )}
    >
      <Clock className="tw-mb-2 tw-text-medium-grey" strokeWidth={2.5} />
      <p className="tw-m-0 tw-text-sm tw-font-normal tw-leading-5 tw-text-primary-grey">
        Registration was reset
      </p>
    </div>
  );
};

export const NoDataAvailable: React.FC<EmptyStateProps> = ({ className = '' }) => {
  return (
    <div
      className={cn(
        'tw-flex tw-flex-col tw-items-center tw-justify-center tw-rounded-md tw-border',
        'tw-border-dashed tw-border-border-grey tw-py-6 tw-text-center',
        className
      )}
    >
      <AlertTriangle className="tw-mb-2 tw-text-medium-grey" strokeWidth={2.5} />
      <p className="tw-m-0 tw-text-sm tw-font-normal tw-leading-5 tw-text-primary-grey">
        No data for this event.{' '}
        <a
          href="https://help.epochapp.com/articles/what-is-confirmations-by-platform"
          target="_blank"
          rel="noopener noreferrer"
          className="tw-text-medium-grey tw-underline"
        >
          Learn more
        </a>
      </p>
    </div>
  );
};
